import { ethers } from "ethers";

/**
 * Retrieves the Token balance for a given evm wallet address.
 * @param rpcUrl - The rpc url for the evm chain as a string.
 * @param wallet - The wallet address as a string.
 * @param address - The token contract address as a string.
 * @returns The balance of token as a number.
 */

export async function fetchEvmTokenBalance(
  rpcUrl: string,
  address: string,
  wallet: string
) {
  if (!ethers.utils.isAddress(wallet)) {
    return "Invalid Ethereum address";
  }

  try {
    const provider = new ethers.providers.JsonRpcProvider(rpcUrl);
    const abi = ["function balanceOf(address) view returns (uint256)"];
    const contract = new ethers.Contract(address, abi, provider);
    const balance = await contract.balanceOf(wallet);
    return Number(ethers.utils.formatUnits(balance, 6)); // ✅ Works in ethers v5
  } catch (err) {
    return 0;
  }
}
